import styled from 'styled-components';
import { breakpoints } from '@vfit/shared/themes';

export const FaqContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 23px 0 24px;

  @media (min-width: ${breakpoints.tablet}) {
    margin: 0 69px 0 32px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    margin: 0 80px;
  }
`;
